import React from 'react';
import PropTypes from 'prop-types';
// import { css } from '@bd/bdui-styles/emotion';
import withData from '@bd/bdcore-data';
import { buildThumbnailUrl } from '@bd/bdcore-utilities';
import PageHelmet from '@bd/bdcore-pagehelmet';
import { get } from 'lodash';
import BuilderAreas from '../../components/BuilderAreas';

import Header from '../../components/Header';
import Footer from '../../components/Footer';
import InsideFyhHeader from '../../components/InsideFyhHeader';
import MenuProduct from '../../components/MenuProduct';
import CtaBanner from '../../components/CtaBanner';
import TestimonialBanner from '../../components/TestimonialBanner';
import FilterBar from '../FilterBar';
import CommunitiesResults from './CommunitiesResults';

const sortOptions = [
  { title: 'Name', field: 'name' },
  { title: 'City', field: 'address.addressLocality' },
  { title: 'Price Low', field: 'priceLow' },
  { title: 'Price High', field: 'priceHigh' },
];

class CardsList extends React.Component {
  constructor(props) {
    super(props);

    const increment = 34;
    this.state = {
      increment,
      limit: increment,
      sort: sortOptions[0],
    };

    this.setSort = this.setSort.bind(this);
  }

  setSort(sort) {
    let dir = '';
    if (sort.field === 'priceHigh') {
      dir = 'desc';
    } else {
      dir = 'asc';
    }
    if (sort.title === this.state.sort.title) {
      dir = this.state.sort.dir === 'desc' ? 'asc' : 'desc';
    }
    this.setState({
      sort: { ...sort, dir },
    });
  }

  render() {
    const { communities, area, metro, submetro, page } = this.props;
    const { limit, sort } = this.state;
    let areaName = `${get(page, 'lead_copy', '')} ${get(page, 'state', '')}`;
    if (area.name) {
      areaName = `${get(area, 'name')} ${get(area, 'state', '')}`;
    } else if (metro.name) {
      areaName = `${metro.name} ${metro.state}`;
    }

    const h2 = submetro.name ? metro.name : undefined;
    const communityImage = get(page, 'page_image.contentUrl') || get(submetro, 'header_image.contentUrl') || get(metro, 'header_image.contentUrl', '');

    return (
      <div className="CommunityList">
        <InsideFyhHeader
          h1={areaName}
          h1Span="New Home Communities"
          h2={h2}
          background={buildThumbnailUrl(communityImage, { width: 2000, height: 2000 })}
        />
        <PageHelmet custom title={`New Home Communities in ${get(area, 'name') || get(page, 'lead_copy')}`} />
        <Header />
        <MenuProduct />
        <FilterBar
          itemCount={communities.length}
          showingCount={limit > communities.length ? communities.length : limit}
          type="communities"
          sortOptions={sortOptions}
          setSortBy={this.setSort}
          filterOptions={[
            {
              type: 'SingleSelect',
              filter: 'Area',
              title: 'Area',
              placeholder: 'All Areas',
              routeParam: 'communityMarketArea',
              onlyFilters: [],
            },
            {
              type: 'MultiSelect',
              filter: 'SchoolDistrict',
              title: 'School Districts',
              placeholder: 'All Districts',
            },
          ]}
        />
        <CommunitiesResults sort={sort} />
        <div style={{ position: 'relative', zIndex: '1' }} id="area-info" >
          <BuilderAreas />
          <CtaBanner />
          <TestimonialBanner />
          <Footer />
        </div>
      </div>
    );
  }
}

CardsList.propTypes = {
  communities: PropTypes.arrayOf(PropTypes.object),
  area: PropTypes.object,
  metro: PropTypes.object,
  submetro: PropTypes.object,
  page: PropTypes.object.isRequired,
};

CardsList.defaultProps = {
  communities: [],
  area: {},
  metro: {},
  submetro: {},
};


export default withData(
  {
    communities: true,
    area: true,
    metro: true,
    submetro: true,
    page: 'communities',
  },
  {
    required: {
      communities: true,
      page: true,
    },
  },
)(CardsList);



// WEBPACK FOOTER //
// ./src/pages/Communities/CardsList.js